// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"resources_js_components_Header_vue":1,"resources_js_components_SliderServices_vue":1,"resources_js_components_SliderTestimonials_vue":1,"resources_js_components_SliderServiceGallery_vue":1,"resources_js_components_OurPeople_vue":1,"resources_js_components_GalleryArea_vue":1,"resources_js_components_Map_vue":1}[chunkId]) return "js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};